import { AccountViewPropertyUnitStatus } from '@zg-rentals/ts-rental-manager-api-client';

import type { ValueOf } from 'type-fest';

export const FLEXIBLE_PROPERTIES_VIEW_MODE = {
  PROPERTIES: 'properties',
  UNITS: 'units',
  BOTH: 'both',
} as const;

export const UNIT_STATUS_LABELS: Record<AccountViewPropertyUnitStatus, string> = {
  [AccountViewPropertyUnitStatus.ARCHIVED]: 'Archived',
  [AccountViewPropertyUnitStatus.LEASED]: 'Leased',
  [AccountViewPropertyUnitStatus.LEASED_AND_LISTED_FOR_RENT]: 'Leased & listed for rent',
  [AccountViewPropertyUnitStatus.LISTED_FOR_RENT]: 'Listed for rent',
  [AccountViewPropertyUnitStatus.VACANT]: 'Vacant',
};

export type FlexiblePropertiesViewMode = ValueOf<typeof FLEXIBLE_PROPERTIES_VIEW_MODE>;

export const DEFAULT_FLEXIBLE_PROPERTIES_VIEW_MODE = FLEXIBLE_PROPERTIES_VIEW_MODE.BOTH;

export const FLEXIBLE_PROPERTIES_EXPANDED_GROUPS_STORAGE_KEY = 'zrm_flexible_properties_expanded_groups';

export { MULTIPLEX_MUTATION_INVALIDATES } from '@zg-rentals/zillow-rental-manager/constants';
